import { Pipe, PipeTransform } from '@angular/core';
import { FieldGroupService } from '../../common/_services/fieldGroup.service';
@Pipe({
  name: 'datagroup',
  pure: true,
  standalone: false,
})
export class DatagroupPipe implements PipeTransform {
  constructor(private fieldGroupService: FieldGroupService) {}

  transform(value: any): any {
    if (!value || value === undefined) {
      return null;
    }

    const selected = this.fieldGroupService.getFieldGroupById(+value);
    if (selected) {
      return selected;
    } else {
      return null;
    }
  }
}
